<template>
  <Link class="" :class="{ 'font-bold': active }">
  <slot />
  </Link>
</template>

<script>
export default {
  props: {
    active: Boolean,
  },
};
</script>